/**
 * SCSS Variables Export
 *
 * This file consolidates all SCSS variables for TypeScript access.
 * Color tokens are auto-generated from _colors.scss.
 * Non-color exports (dimensions, breakpoints) are maintained here.
 *
 * IMPORTANT: Color values are auto-generated. Run `yarn generate:colors` to update.
 * Only modify dimension/breakpoint values manually.
 */

// Import and re-export color tokens from generated file
import colorTokens from './colors.generated'

export * from './colors.generated'
export { colorTokens }
export type { ColorToken } from './colors.generated'

// Dimensions (from dimensions.scss)
export const announcementImageLargeHeight = '49px'
export const announcementImageSmallHeight = '41px'
export const controlWidthMedium = '250px'
export const controlWidthSmall = '180px'
export const fontSizeDefault = '18px'
export const gapLarge = '36px'
export const gapLarger = '48px'
export const gapMedium = '24px'
export const gapSmall = '16px'
export const gapXLarge = '72px'
export const gapXSmall = '8px'
export const gapXXLarge = '144px'
export const gapXXSmall = '5px'
export const iconSizeLarge = '60px'
export const iconSizeMedium = '40px'
export const iconSizeSmall = '20px'
export const iconSizeXSmall = '13px'
export const profileCardGifHeight = '200px'
export const sectionImageHeight = '300px'
export const sectionImageWidth = '320px'
export const sectionVideoHeight = '211px'
export const sectionVideoWidth = '375px'

// Avatar sizes (from dimensions.scss $avatar-sizes map)
export const avatarSizeLarge = '80px' // $icon-size-x-large
export const avatarSizeMedium = '40px' // $icon-size-medium
export const avatarSizeSmall = '20px' // $icon-size-small
export const avatarSizeXlarge = '130px' // $icon-size-xx-large

// Breakpoints (from breakpoints.scss)
export const xxs = '320px'
export const modalButtonLayoutShift = '375px'
export const xs = '480px'
export const sm = '667px'
export const md = '768px'
export const tablet = '900px'
export const lg = '1024px'
export const xl = '1200px'

// Dimension exports for default object
const dimensions = {
    announcementImageLargeHeight,
    announcementImageSmallHeight,
    controlWidthMedium,
    controlWidthSmall,
    fontSizeDefault,
    gapLarge,
    gapLarger,
    gapMedium,
    gapSmall,
    gapXLarge,
    gapXSmall,
    gapXXLarge,
    gapXXSmall,
    iconSizeLarge,
    iconSizeMedium,
    iconSizeSmall,
    iconSizeXSmall,
    profileCardGifHeight,
    sectionImageHeight,
    sectionImageWidth,
    sectionVideoHeight,
    sectionVideoWidth,
    avatarSizeLarge,
    avatarSizeMedium,
    avatarSizeSmall,
    avatarSizeXlarge,
}

const breakpoints = {
    xxs,
    modalButtonLayoutShift,
    xs,
    sm,
    md,
    tablet,
    lg,
    xl,
}

// Default export combines colors, dimensions, and breakpoints for dynamic access
const variables = {
    ...colorTokens,
    ...dimensions,
    ...breakpoints,
}

export type Variable = keyof typeof variables

export default variables
